import { CodeSystem } from "context/elasticsearch/types";
//import { codesystemsEndpointName } from 'utils'

const smallLabCodesystems = new Set([
  CodeSystem.Anatomisk,
  CodeSystem.Provemateriale,
  CodeSystem.Tekstligeresultatverdier,
  CodeSystem.Undersokelsesmetode
]);

const isSmallLabCodesystem = (codeSystem: CodeSystem) => {
  return smallLabCodesystems.has(codeSystem);
};

export default isSmallLabCodesystem;
